import { io } from "socket.io-client";
import jwtDecode from "jwt-decode";
import { store } from ".";
import { setSocketStatus } from "./socket-slice";
import { updateBalance } from "./auth-slice";
import { addNotification } from "./notification-slice";
import { APP_CONFIG } from "../config";

class SocketService {
  constructor() {
    this.socket = null;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.baseDelay = 1000;
  }

  connect(userId) {
    if (this.socket?.connected) return;

    // Initialize socket with auth token
    this.socket = io(APP_CONFIG.API_URL, {
      auth: { userId },
      reconnectionAttempts: this.maxReconnectAttempts,
      reconnectionDelay: this.baseDelay,
      reconnectionDelayMax: 30000, // 30 seconds max delay
      timeout: 20000,
      transports: ["polling"],
      forceNew: true,
    });

    // Connection established
    this.socket.on("connect", () => {
      this.reconnectAttempts = 0;
      store.dispatch(setSocketStatus("connected"));
      console.log("Socket.IO connected");
    });

    // Balance update event
    this.socket.on("balance_update", (data) => {
      console.log("BALANCE UPDATE", data);
      console.log("balance_update", data.balance);
      store.dispatch(
        updateBalance({
          balance: data.balance,
        })
      );
    });
    // Listen for new notifications
    this.socket.on("notification", (notification) => {
      console.log("New notification received:", notification);
      store.dispatch(addNotification(notification));
    });
    // Connection error
    this.socket.on("connect_error", (err) => {
      console.error("Socket connection error:", err.message);
      store.dispatch(setSocketStatus("error"));
    });

    // Reconnecting
    this.socket.on("reconnecting", (attempt) => {
      this.reconnectAttempts = attempt;
      store.dispatch(
        setSocketStatus(
          `reconnecting (${attempt}/${this.maxReconnectAttempts})`
        )
      );
    });

    // Disconnected
    this.socket.on("disconnect", (reason) => {
      console.log("socket disconnected", reason);
      store.dispatch(setSocketStatus("disconnected"));
      if (reason === "io server disconnect") {
        // The server explicitly disconnected, need to manually reconnect
        setTimeout(() => this.connect(userId), 1000);
      }
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      store.dispatch(setSocketStatus("disconnected"));
    }
  }

  // Manual balance refresh request
  requestBalanceRefresh(provider) {
    if (this.socket?.connected) {
      this.socket.emit("request_balance", { provider });
    }
  }
}

export const socketService = new SocketService();
